/**
 * @file schemas.ts
 * @brief Zod schemas for company billing / payment methods.
 *
 * @author DES
 * @date 19-06-2026
 */

import { z } from "zod";

export const PaymentMethodCardSchema = z.object({
  id: z.string(),
  brand: z.string(),
  last4: z.string(),
  expMonth: z.number(),
  expYear: z.number(),
});

export type PaymentMethodCard = z.infer<typeof PaymentMethodCardSchema>;

export const CompanyPaymentMethodsResponseSchema = z.object({
  customerId: z.string().optional(),
  defaultPaymentMethod: z.string().nullable(),
  cards: z.array(PaymentMethodCardSchema).default([]),
});

export type CompanyPaymentMethodsResponse = z.infer<
  typeof CompanyPaymentMethodsResponseSchema
>;

export const SetupIntentResponseSchema = z.object({
  clientSecret: z.string(),
});

export type SetupIntentResponse = z.infer<typeof SetupIntentResponseSchema>;

export const CompanyBillingProfileSchema = z.object({
  id: z.string(),
  name: z.string(),
  billing_email: z.string().nullable().optional(),
  address: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  state: z.string().nullable().optional(),
  postal_code: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
});

export type CompanyBillingProfile = z.infer<typeof CompanyBillingProfileSchema>;

export const CompanyProfileResponseSchema = z.object({
  success: z.literal(true),
  company: CompanyBillingProfileSchema,
});

export type UpdateCompanyBillingProfileInput = {
  address?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  country?: string;
  billing_email?: string;
};

export function isBillingAddressComplete(
  profile: CompanyBillingProfile | undefined,
): boolean {
  return Boolean(profile?.address?.trim() && profile?.country?.trim());
}
